/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetEventTypesDocument = gql`
    query GetEventTypes {
  types {
    id
    type
  }
}
    `;

/**
 * __useGetEventTypesQuery__
 *
 * To run a query within a React component, call `useGetEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEventTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetEventTypesQuery, GetEventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventTypesQuery, GetEventTypesQueryVariables>(GetEventTypesDocument, options);
      }
export function useGetEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventTypesQuery, GetEventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventTypesQuery, GetEventTypesQueryVariables>(GetEventTypesDocument, options);
        }
export function useGetEventTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventTypesQuery, GetEventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventTypesQuery, GetEventTypesQueryVariables>(GetEventTypesDocument, options);
        }
export type GetEventTypesQueryHookResult = ReturnType<typeof useGetEventTypesQuery>;
export type GetEventTypesLazyQueryHookResult = ReturnType<typeof useGetEventTypesLazyQuery>;
export type GetEventTypesSuspenseQueryHookResult = ReturnType<typeof useGetEventTypesSuspenseQuery>;
export type GetEventTypesQueryResult = Apollo.QueryResult<GetEventTypesQuery, GetEventTypesQueryVariables>;
export const GetCitiesbyCountryIdDocument = gql`
    query GetCitiesbyCountryId($countryId: Int!) {
  country(id: $countryId) {
    cities {
      id
      city
    }
  }
}
    `;

/**
 * __useGetCitiesbyCountryIdQuery__
 *
 * To run a query within a React component, call `useGetCitiesbyCountryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesbyCountryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesbyCountryIdQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetCitiesbyCountryIdQuery(baseOptions: Apollo.QueryHookOptions<GetCitiesbyCountryIdQuery, GetCitiesbyCountryIdQueryVariables> & ({ variables: GetCitiesbyCountryIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCitiesbyCountryIdQuery, GetCitiesbyCountryIdQueryVariables>(GetCitiesbyCountryIdDocument, options);
      }
export function useGetCitiesbyCountryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesbyCountryIdQuery, GetCitiesbyCountryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCitiesbyCountryIdQuery, GetCitiesbyCountryIdQueryVariables>(GetCitiesbyCountryIdDocument, options);
        }
export function useGetCitiesbyCountryIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCitiesbyCountryIdQuery, GetCitiesbyCountryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCitiesbyCountryIdQuery, GetCitiesbyCountryIdQueryVariables>(GetCitiesbyCountryIdDocument, options);
        }
export type GetCitiesbyCountryIdQueryHookResult = ReturnType<typeof useGetCitiesbyCountryIdQuery>;
export type GetCitiesbyCountryIdLazyQueryHookResult = ReturnType<typeof useGetCitiesbyCountryIdLazyQuery>;
export type GetCitiesbyCountryIdSuspenseQueryHookResult = ReturnType<typeof useGetCitiesbyCountryIdSuspenseQuery>;
export type GetCitiesbyCountryIdQueryResult = Apollo.QueryResult<GetCitiesbyCountryIdQuery, GetCitiesbyCountryIdQueryVariables>;
export const GetPlacesByCityIdDocument = gql`
    query GetPlacesByCityId($cityId: Int!) {
  placesByCityId(cityId: $cityId) {
    id
    name
    address
  }
}
    `;

/**
 * __useGetPlacesByCityIdQuery__
 *
 * To run a query within a React component, call `useGetPlacesByCityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacesByCityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacesByCityIdQuery({
 *   variables: {
 *      cityId: // value for 'cityId'
 *   },
 * });
 */
export function useGetPlacesByCityIdQuery(baseOptions: Apollo.QueryHookOptions<GetPlacesByCityIdQuery, GetPlacesByCityIdQueryVariables> & ({ variables: GetPlacesByCityIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlacesByCityIdQuery, GetPlacesByCityIdQueryVariables>(GetPlacesByCityIdDocument, options);
      }
export function useGetPlacesByCityIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlacesByCityIdQuery, GetPlacesByCityIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlacesByCityIdQuery, GetPlacesByCityIdQueryVariables>(GetPlacesByCityIdDocument, options);
        }
export function useGetPlacesByCityIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlacesByCityIdQuery, GetPlacesByCityIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlacesByCityIdQuery, GetPlacesByCityIdQueryVariables>(GetPlacesByCityIdDocument, options);
        }
export type GetPlacesByCityIdQueryHookResult = ReturnType<typeof useGetPlacesByCityIdQuery>;
export type GetPlacesByCityIdLazyQueryHookResult = ReturnType<typeof useGetPlacesByCityIdLazyQuery>;
export type GetPlacesByCityIdSuspenseQueryHookResult = ReturnType<typeof useGetPlacesByCityIdSuspenseQuery>;
export type GetPlacesByCityIdQueryResult = Apollo.QueryResult<GetPlacesByCityIdQuery, GetPlacesByCityIdQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories {
  categoriesProxy {
    id
    title
    slug
    children {
      id
      title
    }
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetAllPerformersDocument = gql`
    query GetAllPerformers($page: Int, $search: String) {
  performersProxy(page: $page, search: $search) {
    items {
      id
      name
    }
    pageCount
    currentPage
  }
}
    `;

/**
 * __useGetAllPerformersQuery__
 *
 * To run a query within a React component, call `useGetAllPerformersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPerformersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPerformersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAllPerformersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPerformersQuery, GetAllPerformersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPerformersQuery, GetAllPerformersQueryVariables>(GetAllPerformersDocument, options);
      }
export function useGetAllPerformersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPerformersQuery, GetAllPerformersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPerformersQuery, GetAllPerformersQueryVariables>(GetAllPerformersDocument, options);
        }
export function useGetAllPerformersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllPerformersQuery, GetAllPerformersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllPerformersQuery, GetAllPerformersQueryVariables>(GetAllPerformersDocument, options);
        }
export type GetAllPerformersQueryHookResult = ReturnType<typeof useGetAllPerformersQuery>;
export type GetAllPerformersLazyQueryHookResult = ReturnType<typeof useGetAllPerformersLazyQuery>;
export type GetAllPerformersSuspenseQueryHookResult = ReturnType<typeof useGetAllPerformersSuspenseQuery>;
export type GetAllPerformersQueryResult = Apollo.QueryResult<GetAllPerformersQuery, GetAllPerformersQueryVariables>;
export const GetTicketTypesDocument = gql`
    query GetTicketTypes {
  ticketTypesProxy {
    id
    name
  }
}
    `;

/**
 * __useGetTicketTypesQuery__
 *
 * To run a query within a React component, call `useGetTicketTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTicketTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetTicketTypesQuery, GetTicketTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTicketTypesQuery, GetTicketTypesQueryVariables>(GetTicketTypesDocument, options);
      }
export function useGetTicketTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTicketTypesQuery, GetTicketTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTicketTypesQuery, GetTicketTypesQueryVariables>(GetTicketTypesDocument, options);
        }
export function useGetTicketTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTicketTypesQuery, GetTicketTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTicketTypesQuery, GetTicketTypesQueryVariables>(GetTicketTypesDocument, options);
        }
export type GetTicketTypesQueryHookResult = ReturnType<typeof useGetTicketTypesQuery>;
export type GetTicketTypesLazyQueryHookResult = ReturnType<typeof useGetTicketTypesLazyQuery>;
export type GetTicketTypesSuspenseQueryHookResult = ReturnType<typeof useGetTicketTypesSuspenseQuery>;
export type GetTicketTypesQueryResult = Apollo.QueryResult<GetTicketTypesQuery, GetTicketTypesQueryVariables>;
export const GetPerformerNameByIdDocument = gql`
    query GetPerformerNameById($id: Int!) {
  performerById(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetPerformerNameByIdQuery__
 *
 * To run a query within a React component, call `useGetPerformerNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerformerNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerformerNameByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPerformerNameByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPerformerNameByIdQuery, GetPerformerNameByIdQueryVariables> & ({ variables: GetPerformerNameByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerformerNameByIdQuery, GetPerformerNameByIdQueryVariables>(GetPerformerNameByIdDocument, options);
      }
export function useGetPerformerNameByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerformerNameByIdQuery, GetPerformerNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerformerNameByIdQuery, GetPerformerNameByIdQueryVariables>(GetPerformerNameByIdDocument, options);
        }
export function useGetPerformerNameByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPerformerNameByIdQuery, GetPerformerNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPerformerNameByIdQuery, GetPerformerNameByIdQueryVariables>(GetPerformerNameByIdDocument, options);
        }
export type GetPerformerNameByIdQueryHookResult = ReturnType<typeof useGetPerformerNameByIdQuery>;
export type GetPerformerNameByIdLazyQueryHookResult = ReturnType<typeof useGetPerformerNameByIdLazyQuery>;
export type GetPerformerNameByIdSuspenseQueryHookResult = ReturnType<typeof useGetPerformerNameByIdSuspenseQuery>;
export type GetPerformerNameByIdQueryResult = Apollo.QueryResult<GetPerformerNameByIdQuery, GetPerformerNameByIdQueryVariables>;
export const GetCurrenciesDocument = gql`
    query GetCurrencies {
  currencies {
    name
    id
  }
}
    `;

/**
 * __useGetCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
      }
export function useGetCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
        }
export function useGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
        }
export type GetCurrenciesQueryHookResult = ReturnType<typeof useGetCurrenciesQuery>;
export type GetCurrenciesLazyQueryHookResult = ReturnType<typeof useGetCurrenciesLazyQuery>;
export type GetCurrenciesSuspenseQueryHookResult = ReturnType<typeof useGetCurrenciesSuspenseQuery>;
export type GetCurrenciesQueryResult = Apollo.QueryResult<GetCurrenciesQuery, GetCurrenciesQueryVariables>;
export const CreateEventDocument = gql`
    mutation CreateEvent($banner: Upload, $event: NewEventTypeInput!, $gallery: [Upload!], $poster: Upload!) {
  createEvent(banner: $banner, event: $event, gallery: $gallery, poster: $poster) {
    id
    title
    payments {
      id
      name
      stripeId
      payoneerId
      country
      stripeConnectBankAccountId
      stripeAlternativeTransferStatus
      stripeStatus
      type
    }
    galleryImages {
      id
      fileName
    }
    bannerImage {
      id
      fileName
    }
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      banner: // value for 'banner'
 *      event: // value for 'event'
 *      gallery: // value for 'gallery'
 *      poster: // value for 'poster'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($eventId: Int!, $banner: Upload, $event: NewEventTypeInput!, $gallery: [Upload!], $poster: Upload!) {
  updateEvent(
    eventId: $eventId
    banner: $banner
    event: $event
    gallery: $gallery
    poster: $poster
  ) {
    id
    galleryImages {
      id
      fileName
    }
    bannerImage {
      id
      fileName
    }
  }
}
    `;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      banner: // value for 'banner'
 *      event: // value for 'event'
 *      gallery: // value for 'gallery'
 *      poster: // value for 'poster'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const GetStripeCountriesDocument = gql`
    query GetStripeCountries {
  stripeCountries {
    country
    id
    code
  }
}
    `;

/**
 * __useGetStripeCountriesQuery__
 *
 * To run a query within a React component, call `useGetStripeCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripeCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetStripeCountriesQuery, GetStripeCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeCountriesQuery, GetStripeCountriesQueryVariables>(GetStripeCountriesDocument, options);
      }
export function useGetStripeCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeCountriesQuery, GetStripeCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeCountriesQuery, GetStripeCountriesQueryVariables>(GetStripeCountriesDocument, options);
        }
export function useGetStripeCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStripeCountriesQuery, GetStripeCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStripeCountriesQuery, GetStripeCountriesQueryVariables>(GetStripeCountriesDocument, options);
        }
export type GetStripeCountriesQueryHookResult = ReturnType<typeof useGetStripeCountriesQuery>;
export type GetStripeCountriesLazyQueryHookResult = ReturnType<typeof useGetStripeCountriesLazyQuery>;
export type GetStripeCountriesSuspenseQueryHookResult = ReturnType<typeof useGetStripeCountriesSuspenseQuery>;
export type GetStripeCountriesQueryResult = Apollo.QueryResult<GetStripeCountriesQuery, GetStripeCountriesQueryVariables>;
export const CreateOrUpdatePaymentTicketOfficeDocument = gql`
    mutation CreateOrUpdatePaymentTicketOffice($eventId: Int!, $input: PaymentTicketOfficeTypeInput!, $ticketOfficeType: PaymentsTicketOfficeTypeEnum) {
  createOrUpdatePaymentTicketOffice(
    eventId: $eventId
    input: $input
    ticketOfficeType: $ticketOfficeType
  ) {
    paymentsProxyType {
      type
    }
  }
}
    `;
export type CreateOrUpdatePaymentTicketOfficeMutationFn = Apollo.MutationFunction<CreateOrUpdatePaymentTicketOfficeMutation, CreateOrUpdatePaymentTicketOfficeMutationVariables>;

/**
 * __useCreateOrUpdatePaymentTicketOfficeMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdatePaymentTicketOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdatePaymentTicketOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdatePaymentTicketOfficeMutation, { data, loading, error }] = useCreateOrUpdatePaymentTicketOfficeMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *      ticketOfficeType: // value for 'ticketOfficeType'
 *   },
 * });
 */
export function useCreateOrUpdatePaymentTicketOfficeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdatePaymentTicketOfficeMutation, CreateOrUpdatePaymentTicketOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdatePaymentTicketOfficeMutation, CreateOrUpdatePaymentTicketOfficeMutationVariables>(CreateOrUpdatePaymentTicketOfficeDocument, options);
      }
export type CreateOrUpdatePaymentTicketOfficeMutationHookResult = ReturnType<typeof useCreateOrUpdatePaymentTicketOfficeMutation>;
export type CreateOrUpdatePaymentTicketOfficeMutationResult = Apollo.MutationResult<CreateOrUpdatePaymentTicketOfficeMutation>;
export type CreateOrUpdatePaymentTicketOfficeMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdatePaymentTicketOfficeMutation, CreateOrUpdatePaymentTicketOfficeMutationVariables>;
export const CreateOrUpdatePaymentStripeAccountDocument = gql`
    mutation CreateOrUpdatePaymentStripeAccount($eventId: Int!, $input: PaymentStripeAccountTypeInput!, $returnUrl: String!) {
  createOrUpdatePaymentStripeAccount(
    eventId: $eventId
    input: $input
    returnUrl: $returnUrl
  ) {
    redirectUrl
  }
}
    `;
export type CreateOrUpdatePaymentStripeAccountMutationFn = Apollo.MutationFunction<CreateOrUpdatePaymentStripeAccountMutation, CreateOrUpdatePaymentStripeAccountMutationVariables>;

/**
 * __useCreateOrUpdatePaymentStripeAccountMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdatePaymentStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdatePaymentStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdatePaymentStripeAccountMutation, { data, loading, error }] = useCreateOrUpdatePaymentStripeAccountMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useCreateOrUpdatePaymentStripeAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdatePaymentStripeAccountMutation, CreateOrUpdatePaymentStripeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdatePaymentStripeAccountMutation, CreateOrUpdatePaymentStripeAccountMutationVariables>(CreateOrUpdatePaymentStripeAccountDocument, options);
      }
export type CreateOrUpdatePaymentStripeAccountMutationHookResult = ReturnType<typeof useCreateOrUpdatePaymentStripeAccountMutation>;
export type CreateOrUpdatePaymentStripeAccountMutationResult = Apollo.MutationResult<CreateOrUpdatePaymentStripeAccountMutation>;
export type CreateOrUpdatePaymentStripeAccountMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdatePaymentStripeAccountMutation, CreateOrUpdatePaymentStripeAccountMutationVariables>;
export const CreateOrUpdatePaymentStripeAlternativeDocument = gql`
    mutation CreateOrUpdatePaymentStripeAlternative($eventId: Int!, $input: PaymentStripeAlternativeTypeInput!) {
  createOrUpdatePaymentStripeAlternative(eventId: $eventId, input: $input) {
    paymentsProxyType {
      id
    }
  }
}
    `;
export type CreateOrUpdatePaymentStripeAlternativeMutationFn = Apollo.MutationFunction<CreateOrUpdatePaymentStripeAlternativeMutation, CreateOrUpdatePaymentStripeAlternativeMutationVariables>;

/**
 * __useCreateOrUpdatePaymentStripeAlternativeMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdatePaymentStripeAlternativeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdatePaymentStripeAlternativeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdatePaymentStripeAlternativeMutation, { data, loading, error }] = useCreateOrUpdatePaymentStripeAlternativeMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdatePaymentStripeAlternativeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdatePaymentStripeAlternativeMutation, CreateOrUpdatePaymentStripeAlternativeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdatePaymentStripeAlternativeMutation, CreateOrUpdatePaymentStripeAlternativeMutationVariables>(CreateOrUpdatePaymentStripeAlternativeDocument, options);
      }
export type CreateOrUpdatePaymentStripeAlternativeMutationHookResult = ReturnType<typeof useCreateOrUpdatePaymentStripeAlternativeMutation>;
export type CreateOrUpdatePaymentStripeAlternativeMutationResult = Apollo.MutationResult<CreateOrUpdatePaymentStripeAlternativeMutation>;
export type CreateOrUpdatePaymentStripeAlternativeMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdatePaymentStripeAlternativeMutation, CreateOrUpdatePaymentStripeAlternativeMutationVariables>;
export const CreateBankAccountDocument = gql`
    mutation CreateBankAccount($eventId: Int!, $input: BankAccountTypeInput!) {
  createBankAccount(eventId: $eventId, input: $input) {
    id
  }
}
    `;
export type CreateBankAccountMutationFn = Apollo.MutationFunction<CreateBankAccountMutation, CreateBankAccountMutationVariables>;

/**
 * __useCreateBankAccountMutation__
 *
 * To run a mutation, you first call `useCreateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBankAccountMutation, { data, loading, error }] = useCreateBankAccountMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateBankAccountMutation, CreateBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBankAccountMutation, CreateBankAccountMutationVariables>(CreateBankAccountDocument, options);
      }
export type CreateBankAccountMutationHookResult = ReturnType<typeof useCreateBankAccountMutation>;
export type CreateBankAccountMutationResult = Apollo.MutationResult<CreateBankAccountMutation>;
export type CreateBankAccountMutationOptions = Apollo.BaseMutationOptions<CreateBankAccountMutation, CreateBankAccountMutationVariables>;
export const GetEventProxyDocument = gql`
    query GetEventProxy($eventId: Int!) {
  eventProxy(id: $eventId) {
    bannerImage {
      link
      id
      fileName
    }
    categories {
      id
      title
    }
    description
    endDate
    timezone {
      id
    }
    eventCurrency
    galleryImages {
      id
      fileName
      link
    }
    id
    isOnline
    posterImage {
      fileName
      link
    }
    startDate
    title
    tickets {
      id
      price
      quantity
      currency
      description
      startTicketSales
      endTicketSales
      limitQuantity
      ticketSalesInterval
      type {
        id
        name
      }
    }
    ticketReturn {
      id
      isPossible
      description
      contacts {
        id
        email
        phone
      }
    }
    place {
      id
      name
      address
      city {
        id
        city
        country {
          id
          country
          code
        }
        places {
          name
        }
      }
    }
    platform {
      id
      invitationLink
      platformUseGuidelines
    }
    performers {
      id
      name
    }
    payments {
      id
      name
      type
      stripeId
      payoneerId
      country
      stripeConnectBankAccountId
      stripeAlternativeTransferStatus
      stripeStatus
      stripeAlternative {
        id
        email
        phone
        address
        postalCode
        nameOfTheBank
        accountHolderName
        iban
        feePayerType
        swiftOrBic
        accountNumber
      }
      ticketOfficeType
    }
    eventCashInfos {
      id
      phones
      emails
      addresses
    }
    isRecurring
    recurrence {
      startDate
      endDate
      rrule
    }
    status
    catalogApprove
    ticketSoldOutForUpcomingRecurringEvents
  }
}
    `;

/**
 * __useGetEventProxyQuery__
 *
 * To run a query within a React component, call `useGetEventProxyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventProxyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventProxyQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventProxyQuery(baseOptions: Apollo.QueryHookOptions<GetEventProxyQuery, GetEventProxyQueryVariables> & ({ variables: GetEventProxyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventProxyQuery, GetEventProxyQueryVariables>(GetEventProxyDocument, options);
      }
export function useGetEventProxyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventProxyQuery, GetEventProxyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventProxyQuery, GetEventProxyQueryVariables>(GetEventProxyDocument, options);
        }
export function useGetEventProxySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventProxyQuery, GetEventProxyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventProxyQuery, GetEventProxyQueryVariables>(GetEventProxyDocument, options);
        }
export type GetEventProxyQueryHookResult = ReturnType<typeof useGetEventProxyQuery>;
export type GetEventProxyLazyQueryHookResult = ReturnType<typeof useGetEventProxyLazyQuery>;
export type GetEventProxySuspenseQueryHookResult = ReturnType<typeof useGetEventProxySuspenseQuery>;
export type GetEventProxyQueryResult = Apollo.QueryResult<GetEventProxyQuery, GetEventProxyQueryVariables>;
export const GetStripeCurrenciesDocument = gql`
    query getStripeCurrencies {
  stripeCurrencies {
    id
    name
  }
}
    `;

/**
 * __useGetStripeCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetStripeCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripeCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GetStripeCurrenciesQuery, GetStripeCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeCurrenciesQuery, GetStripeCurrenciesQueryVariables>(GetStripeCurrenciesDocument, options);
      }
export function useGetStripeCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeCurrenciesQuery, GetStripeCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeCurrenciesQuery, GetStripeCurrenciesQueryVariables>(GetStripeCurrenciesDocument, options);
        }
export function useGetStripeCurrenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStripeCurrenciesQuery, GetStripeCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStripeCurrenciesQuery, GetStripeCurrenciesQueryVariables>(GetStripeCurrenciesDocument, options);
        }
export type GetStripeCurrenciesQueryHookResult = ReturnType<typeof useGetStripeCurrenciesQuery>;
export type GetStripeCurrenciesLazyQueryHookResult = ReturnType<typeof useGetStripeCurrenciesLazyQuery>;
export type GetStripeCurrenciesSuspenseQueryHookResult = ReturnType<typeof useGetStripeCurrenciesSuspenseQuery>;
export type GetStripeCurrenciesQueryResult = Apollo.QueryResult<GetStripeCurrenciesQuery, GetStripeCurrenciesQueryVariables>;
export const GetOrganizerPaymentsDocument = gql`
    query GetOrganizerPayments {
  organizer {
    email
    payments {
      id
      type
      stripeId
      country
      stripeConnectBankAccountId
    }
  }
}
    `;

/**
 * __useGetOrganizerPaymentsQuery__
 *
 * To run a query within a React component, call `useGetOrganizerPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizerPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizerPaymentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizerPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizerPaymentsQuery, GetOrganizerPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizerPaymentsQuery, GetOrganizerPaymentsQueryVariables>(GetOrganizerPaymentsDocument, options);
      }
export function useGetOrganizerPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizerPaymentsQuery, GetOrganizerPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizerPaymentsQuery, GetOrganizerPaymentsQueryVariables>(GetOrganizerPaymentsDocument, options);
        }
export function useGetOrganizerPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizerPaymentsQuery, GetOrganizerPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizerPaymentsQuery, GetOrganizerPaymentsQueryVariables>(GetOrganizerPaymentsDocument, options);
        }
export type GetOrganizerPaymentsQueryHookResult = ReturnType<typeof useGetOrganizerPaymentsQuery>;
export type GetOrganizerPaymentsLazyQueryHookResult = ReturnType<typeof useGetOrganizerPaymentsLazyQuery>;
export type GetOrganizerPaymentsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizerPaymentsSuspenseQuery>;
export type GetOrganizerPaymentsQueryResult = Apollo.QueryResult<GetOrganizerPaymentsQuery, GetOrganizerPaymentsQueryVariables>;
export const GetEventPaymentsDocument = gql`
    query GetEventPayments($eventId: Int!) {
  eventProxy(id: $eventId) {
    payments {
      type
      stripeConnectBankAccountId
    }
  }
}
    `;

/**
 * __useGetEventPaymentsQuery__
 *
 * To run a query within a React component, call `useGetEventPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventPaymentsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventPaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetEventPaymentsQuery, GetEventPaymentsQueryVariables> & ({ variables: GetEventPaymentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventPaymentsQuery, GetEventPaymentsQueryVariables>(GetEventPaymentsDocument, options);
      }
export function useGetEventPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventPaymentsQuery, GetEventPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventPaymentsQuery, GetEventPaymentsQueryVariables>(GetEventPaymentsDocument, options);
        }
export function useGetEventPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventPaymentsQuery, GetEventPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventPaymentsQuery, GetEventPaymentsQueryVariables>(GetEventPaymentsDocument, options);
        }
export type GetEventPaymentsQueryHookResult = ReturnType<typeof useGetEventPaymentsQuery>;
export type GetEventPaymentsLazyQueryHookResult = ReturnType<typeof useGetEventPaymentsLazyQuery>;
export type GetEventPaymentsSuspenseQueryHookResult = ReturnType<typeof useGetEventPaymentsSuspenseQuery>;
export type GetEventPaymentsQueryResult = Apollo.QueryResult<GetEventPaymentsQuery, GetEventPaymentsQueryVariables>;
export const SetPaymentStripeDocument = gql`
    mutation SetPaymentStripe($eventId: Int!, $paymentId: Int!, $returnUrl: String!) {
  setPaymentStripe(
    eventId: $eventId
    paymentId: $paymentId
    returnUrl: $returnUrl
  ) {
    redirectUrl
    paymentsProxyType {
      stripeConnectBankAccountId
    }
  }
}
    `;
export type SetPaymentStripeMutationFn = Apollo.MutationFunction<SetPaymentStripeMutation, SetPaymentStripeMutationVariables>;

/**
 * __useSetPaymentStripeMutation__
 *
 * To run a mutation, you first call `useSetPaymentStripeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentStripeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPaymentStripeMutation, { data, loading, error }] = useSetPaymentStripeMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      paymentId: // value for 'paymentId'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useSetPaymentStripeMutation(baseOptions?: Apollo.MutationHookOptions<SetPaymentStripeMutation, SetPaymentStripeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPaymentStripeMutation, SetPaymentStripeMutationVariables>(SetPaymentStripeDocument, options);
      }
export type SetPaymentStripeMutationHookResult = ReturnType<typeof useSetPaymentStripeMutation>;
export type SetPaymentStripeMutationResult = Apollo.MutationResult<SetPaymentStripeMutation>;
export type SetPaymentStripeMutationOptions = Apollo.BaseMutationOptions<SetPaymentStripeMutation, SetPaymentStripeMutationVariables>;
export const DeleteEventGalleryImageDocument = gql`
    mutation DeleteEventGalleryImage($eventId: Int!, $imageId: Int!) {
  deleteEventGalleryImage(eventId: $eventId, imageId: $imageId) {
    id
  }
}
    `;
export type DeleteEventGalleryImageMutationFn = Apollo.MutationFunction<DeleteEventGalleryImageMutation, DeleteEventGalleryImageMutationVariables>;

/**
 * __useDeleteEventGalleryImageMutation__
 *
 * To run a mutation, you first call `useDeleteEventGalleryImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventGalleryImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventGalleryImageMutation, { data, loading, error }] = useDeleteEventGalleryImageMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useDeleteEventGalleryImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventGalleryImageMutation, DeleteEventGalleryImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventGalleryImageMutation, DeleteEventGalleryImageMutationVariables>(DeleteEventGalleryImageDocument, options);
      }
export type DeleteEventGalleryImageMutationHookResult = ReturnType<typeof useDeleteEventGalleryImageMutation>;
export type DeleteEventGalleryImageMutationResult = Apollo.MutationResult<DeleteEventGalleryImageMutation>;
export type DeleteEventGalleryImageMutationOptions = Apollo.BaseMutationOptions<DeleteEventGalleryImageMutation, DeleteEventGalleryImageMutationVariables>;
export const DeleteEventBannerImageDocument = gql`
    mutation DeleteEventBannerImage($eventId: Int!) {
  deleteEventBannerImage(eventId: $eventId) {
    id
  }
}
    `;
export type DeleteEventBannerImageMutationFn = Apollo.MutationFunction<DeleteEventBannerImageMutation, DeleteEventBannerImageMutationVariables>;

/**
 * __useDeleteEventBannerImageMutation__
 *
 * To run a mutation, you first call `useDeleteEventBannerImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventBannerImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventBannerImageMutation, { data, loading, error }] = useDeleteEventBannerImageMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useDeleteEventBannerImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventBannerImageMutation, DeleteEventBannerImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventBannerImageMutation, DeleteEventBannerImageMutationVariables>(DeleteEventBannerImageDocument, options);
      }
export type DeleteEventBannerImageMutationHookResult = ReturnType<typeof useDeleteEventBannerImageMutation>;
export type DeleteEventBannerImageMutationResult = Apollo.MutationResult<DeleteEventBannerImageMutation>;
export type DeleteEventBannerImageMutationOptions = Apollo.BaseMutationOptions<DeleteEventBannerImageMutation, DeleteEventBannerImageMutationVariables>;
export const PublishEventDocument = gql`
    mutation PublishEvent($eventId: Int!) {
  publishEvent(eventId: $eventId)
}
    `;
export type PublishEventMutationFn = Apollo.MutationFunction<PublishEventMutation, PublishEventMutationVariables>;

/**
 * __usePublishEventMutation__
 *
 * To run a mutation, you first call `usePublishEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishEventMutation, { data, loading, error }] = usePublishEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function usePublishEventMutation(baseOptions?: Apollo.MutationHookOptions<PublishEventMutation, PublishEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishEventMutation, PublishEventMutationVariables>(PublishEventDocument, options);
      }
export type PublishEventMutationHookResult = ReturnType<typeof usePublishEventMutation>;
export type PublishEventMutationResult = Apollo.MutationResult<PublishEventMutation>;
export type PublishEventMutationOptions = Apollo.BaseMutationOptions<PublishEventMutation, PublishEventMutationVariables>;
export const GetCountriesDocument = gql`
    query GetCountries {
  countries {
    country
    id
    currency
    code
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export function useGetCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesSuspenseQueryHookResult = ReturnType<typeof useGetCountriesSuspenseQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const GetOrganizerServiceInfoDocument = gql`
    query GetOrganizerServiceInfo {
  activeSubscription
  needVerifyEmail
}
    `;

/**
 * __useGetOrganizerServiceInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizerServiceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizerServiceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizerServiceInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizerServiceInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizerServiceInfoQuery, GetOrganizerServiceInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizerServiceInfoQuery, GetOrganizerServiceInfoQueryVariables>(GetOrganizerServiceInfoDocument, options);
      }
export function useGetOrganizerServiceInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizerServiceInfoQuery, GetOrganizerServiceInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizerServiceInfoQuery, GetOrganizerServiceInfoQueryVariables>(GetOrganizerServiceInfoDocument, options);
        }
export function useGetOrganizerServiceInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizerServiceInfoQuery, GetOrganizerServiceInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizerServiceInfoQuery, GetOrganizerServiceInfoQueryVariables>(GetOrganizerServiceInfoDocument, options);
        }
export type GetOrganizerServiceInfoQueryHookResult = ReturnType<typeof useGetOrganizerServiceInfoQuery>;
export type GetOrganizerServiceInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizerServiceInfoLazyQuery>;
export type GetOrganizerServiceInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganizerServiceInfoSuspenseQuery>;
export type GetOrganizerServiceInfoQueryResult = Apollo.QueryResult<GetOrganizerServiceInfoQuery, GetOrganizerServiceInfoQueryVariables>;
export const TimezonesProxyDocument = gql`
    query TimezonesProxy {
  timezonesProxy {
    id
    name
    gmt
  }
}
    `;

/**
 * __useTimezonesProxyQuery__
 *
 * To run a query within a React component, call `useTimezonesProxyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimezonesProxyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimezonesProxyQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimezonesProxyQuery(baseOptions?: Apollo.QueryHookOptions<TimezonesProxyQuery, TimezonesProxyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimezonesProxyQuery, TimezonesProxyQueryVariables>(TimezonesProxyDocument, options);
      }
export function useTimezonesProxyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimezonesProxyQuery, TimezonesProxyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimezonesProxyQuery, TimezonesProxyQueryVariables>(TimezonesProxyDocument, options);
        }
export function useTimezonesProxySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimezonesProxyQuery, TimezonesProxyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimezonesProxyQuery, TimezonesProxyQueryVariables>(TimezonesProxyDocument, options);
        }
export type TimezonesProxyQueryHookResult = ReturnType<typeof useTimezonesProxyQuery>;
export type TimezonesProxyLazyQueryHookResult = ReturnType<typeof useTimezonesProxyLazyQuery>;
export type TimezonesProxySuspenseQueryHookResult = ReturnType<typeof useTimezonesProxySuspenseQuery>;
export type TimezonesProxyQueryResult = Apollo.QueryResult<TimezonesProxyQuery, TimezonesProxyQueryVariables>;
export const PaymentCountryDocument = gql`
    query PaymentCountry($countryCode: String!) {
  paymentCountry(countryCode: $countryCode) {
    name
    currencies
    routing
    swift
    number
    iban
  }
}
    `;

/**
 * __usePaymentCountryQuery__
 *
 * To run a query within a React component, call `usePaymentCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentCountryQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function usePaymentCountryQuery(baseOptions: Apollo.QueryHookOptions<PaymentCountryQuery, PaymentCountryQueryVariables> & ({ variables: PaymentCountryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentCountryQuery, PaymentCountryQueryVariables>(PaymentCountryDocument, options);
      }
export function usePaymentCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentCountryQuery, PaymentCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentCountryQuery, PaymentCountryQueryVariables>(PaymentCountryDocument, options);
        }
export function usePaymentCountrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentCountryQuery, PaymentCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentCountryQuery, PaymentCountryQueryVariables>(PaymentCountryDocument, options);
        }
export type PaymentCountryQueryHookResult = ReturnType<typeof usePaymentCountryQuery>;
export type PaymentCountryLazyQueryHookResult = ReturnType<typeof usePaymentCountryLazyQuery>;
export type PaymentCountrySuspenseQueryHookResult = ReturnType<typeof usePaymentCountrySuspenseQuery>;
export type PaymentCountryQueryResult = Apollo.QueryResult<PaymentCountryQuery, PaymentCountryQueryVariables>;
export const GetOrganizerBanInfoDocument = gql`
    query GetOrganizerBanInfo {
  organizer {
    banActive
  }
}
    `;

/**
 * __useGetOrganizerBanInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizerBanInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizerBanInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizerBanInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizerBanInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizerBanInfoQuery, GetOrganizerBanInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizerBanInfoQuery, GetOrganizerBanInfoQueryVariables>(GetOrganizerBanInfoDocument, options);
      }
export function useGetOrganizerBanInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizerBanInfoQuery, GetOrganizerBanInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizerBanInfoQuery, GetOrganizerBanInfoQueryVariables>(GetOrganizerBanInfoDocument, options);
        }
export function useGetOrganizerBanInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizerBanInfoQuery, GetOrganizerBanInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizerBanInfoQuery, GetOrganizerBanInfoQueryVariables>(GetOrganizerBanInfoDocument, options);
        }
export type GetOrganizerBanInfoQueryHookResult = ReturnType<typeof useGetOrganizerBanInfoQuery>;
export type GetOrganizerBanInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizerBanInfoLazyQuery>;
export type GetOrganizerBanInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganizerBanInfoSuspenseQuery>;
export type GetOrganizerBanInfoQueryResult = Apollo.QueryResult<GetOrganizerBanInfoQuery, GetOrganizerBanInfoQueryVariables>;
export const DeleteTicketOfficeDocument = gql`
    mutation DeleteTicketOffice($eventId: Int!) {
  deleteTicketOffice(eventId: $eventId) {
    id
  }
}
    `;
export type DeleteTicketOfficeMutationFn = Apollo.MutationFunction<DeleteTicketOfficeMutation, DeleteTicketOfficeMutationVariables>;

/**
 * __useDeleteTicketOfficeMutation__
 *
 * To run a mutation, you first call `useDeleteTicketOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTicketOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTicketOfficeMutation, { data, loading, error }] = useDeleteTicketOfficeMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useDeleteTicketOfficeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTicketOfficeMutation, DeleteTicketOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTicketOfficeMutation, DeleteTicketOfficeMutationVariables>(DeleteTicketOfficeDocument, options);
      }
export type DeleteTicketOfficeMutationHookResult = ReturnType<typeof useDeleteTicketOfficeMutation>;
export type DeleteTicketOfficeMutationResult = Apollo.MutationResult<DeleteTicketOfficeMutation>;
export type DeleteTicketOfficeMutationOptions = Apollo.BaseMutationOptions<DeleteTicketOfficeMutation, DeleteTicketOfficeMutationVariables>;
export type GetEventTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetEventTypesQuery = { __typename?: 'Query', types: Array<{ __typename?: 'Types', id?: number | null, type?: string | null }> };

export type GetCitiesbyCountryIdQueryVariables = Types.Exact<{
  countryId: Types.Scalars['Int']['input'];
}>;


export type GetCitiesbyCountryIdQuery = { __typename?: 'Query', country?: { __typename?: 'CountryProxyType', cities: Array<{ __typename?: 'CityProxyType', id: number, city?: string | null }> } | null };

export type GetPlacesByCityIdQueryVariables = Types.Exact<{
  cityId: Types.Scalars['Int']['input'];
}>;


export type GetPlacesByCityIdQuery = { __typename?: 'Query', placesByCityId: Array<{ __typename?: 'Place', id?: number | null, name?: string | null, address?: string | null }> };

export type GetCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = { __typename?: 'Query', categoriesProxy: Array<{ __typename?: 'CategoryProxyType', id: number, title?: string | null, slug?: string | null, children: Array<{ __typename?: 'CategoryProxyType', id: number, title?: string | null }> }> };

export type GetAllPerformersQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllPerformersQuery = { __typename?: 'Query', performersProxy: { __typename?: 'PerformerPaginatedType', pageCount?: string | null, currentPage?: number | null, items: Array<{ __typename?: 'PerformerProxyType', id: number, name?: string | null }> } };

export type GetTicketTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTicketTypesQuery = { __typename?: 'Query', ticketTypesProxy: Array<{ __typename?: 'TicketTypeProxyType', id: number, name?: string | null }> };

export type GetPerformerNameByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetPerformerNameByIdQuery = { __typename?: 'Query', performerById: { __typename?: 'Performer', id?: number | null, name?: string | null } };

export type GetCurrenciesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrenciesQuery = { __typename?: 'Query', currencies: Array<{ __typename?: 'CurrencyProxyType', name?: string | null, id: number }> };

export type CreateEventMutationVariables = Types.Exact<{
  banner?: Types.InputMaybe<Types.Scalars['Upload']['input']>;
  event: Types.NewEventTypeInput;
  gallery?: Types.InputMaybe<Array<Types.Scalars['Upload']['input']> | Types.Scalars['Upload']['input']>;
  poster: Types.Scalars['Upload']['input'];
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'EventProxyType', id: number, title: string, payments: Array<{ __typename?: 'PaymentsProxyType', id: number, name?: string | null, stripeId?: string | null, payoneerId?: string | null, country?: string | null, stripeConnectBankAccountId?: string | null, stripeAlternativeTransferStatus?: string | null, stripeStatus?: number | null, type?: string | null }>, galleryImages: Array<{ __typename?: 'ImageProxyType', id: number, fileName: string }>, bannerImage?: { __typename?: 'ImageProxyType', id: number, fileName: string } | null } };

export type UpdateEventMutationVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
  banner?: Types.InputMaybe<Types.Scalars['Upload']['input']>;
  event: Types.NewEventTypeInput;
  gallery?: Types.InputMaybe<Array<Types.Scalars['Upload']['input']> | Types.Scalars['Upload']['input']>;
  poster: Types.Scalars['Upload']['input'];
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'EventProxyType', id: number, galleryImages: Array<{ __typename?: 'ImageProxyType', id: number, fileName: string }>, bannerImage?: { __typename?: 'ImageProxyType', id: number, fileName: string } | null } };

export type GetStripeCountriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetStripeCountriesQuery = { __typename?: 'Query', stripeCountries: Array<{ __typename?: 'CountryProxyType', country?: string | null, id: number, code?: string | null }> };

export type CreateOrUpdatePaymentTicketOfficeMutationVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
  input: Types.PaymentTicketOfficeTypeInput;
  ticketOfficeType?: Types.InputMaybe<Types.PaymentsTicketOfficeTypeEnum>;
}>;


export type CreateOrUpdatePaymentTicketOfficeMutation = { __typename?: 'Mutation', createOrUpdatePaymentTicketOffice: { __typename?: 'TicketOfficeResponseType', paymentsProxyType: { __typename?: 'PaymentsProxyType', type?: string | null } } };

export type CreateOrUpdatePaymentStripeAccountMutationVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
  input: Types.PaymentStripeAccountTypeInput;
  returnUrl: Types.Scalars['String']['input'];
}>;


export type CreateOrUpdatePaymentStripeAccountMutation = { __typename?: 'Mutation', createOrUpdatePaymentStripeAccount: { __typename?: 'StripeResponseType', redirectUrl: string } };

export type CreateOrUpdatePaymentStripeAlternativeMutationVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
  input: Types.PaymentStripeAlternativeTypeInput;
}>;


export type CreateOrUpdatePaymentStripeAlternativeMutation = { __typename?: 'Mutation', createOrUpdatePaymentStripeAlternative: { __typename?: 'StripeAlternativeResponseType', paymentsProxyType: { __typename?: 'PaymentsProxyType', id: number } } };

export type CreateBankAccountMutationVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
  input: Types.BankAccountTypeInput;
}>;


export type CreateBankAccountMutation = { __typename?: 'Mutation', createBankAccount: { __typename?: 'PaymentsProxyType', id: number } };

export type GetEventProxyQueryVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
}>;


export type GetEventProxyQuery = { __typename?: 'Query', eventProxy?: { __typename?: 'EventProxyType', description: string, endDate?: any | null, eventCurrency?: string | null, id: number, isOnline: boolean, startDate?: any | null, title: string, isRecurring: boolean, status: number, catalogApprove: boolean, ticketSoldOutForUpcomingRecurringEvents: number, bannerImage?: { __typename?: 'ImageProxyType', link: string, id: number, fileName: string } | null, categories: Array<{ __typename?: 'CategoryProxyType', id: number, title?: string | null }>, timezone?: { __typename?: 'TimezoneProxyType', id: number } | null, galleryImages: Array<{ __typename?: 'ImageProxyType', id: number, fileName: string, link: string }>, posterImage?: { __typename?: 'ImageProxyType', fileName: string, link: string } | null, tickets: Array<{ __typename?: 'TicketProxyType', id: number, price?: number | null, quantity?: number | null, currency?: string | null, description?: string | null, startTicketSales?: any | null, endTicketSales?: any | null, limitQuantity?: number | null, ticketSalesInterval?: any | null, type: { __typename?: 'TicketTypeProxyType', id: number, name?: string | null } }>, ticketReturn?: { __typename?: 'TicketReturnProxyType', id: number, isPossible?: boolean | null, description?: string | null, contacts: Array<{ __typename?: 'TicketReturnContactProxyType', id: number, email?: string | null, phone?: string | null }> } | null, place?: { __typename?: 'PlaceProxyType', id: number, name?: string | null, address?: string | null, city?: { __typename?: 'CityProxyType', id: number, city?: string | null, country?: { __typename?: 'CountryProxyType', id: number, country?: string | null, code?: string | null } | null, places: Array<{ __typename?: 'PlaceProxyType', name?: string | null }> } | null } | null, platform?: { __typename?: 'PlatformProxyType', id: number, invitationLink?: string | null, platformUseGuidelines?: string | null } | null, performers: Array<{ __typename?: 'PerformerProxyType', id: number, name?: string | null }>, payments: Array<{ __typename?: 'PaymentsProxyType', id: number, name?: string | null, type?: string | null, stripeId?: string | null, payoneerId?: string | null, country?: string | null, stripeConnectBankAccountId?: string | null, stripeAlternativeTransferStatus?: string | null, stripeStatus?: number | null, ticketOfficeType?: number | null, stripeAlternative?: { __typename?: 'StripeAlternativeProxyType', id: number, email?: string | null, phone?: string | null, address?: string | null, postalCode?: string | null, nameOfTheBank?: string | null, accountHolderName?: string | null, iban?: string | null, feePayerType?: number | null, swiftOrBic?: string | null, accountNumber?: string | null } | null }>, eventCashInfos: Array<{ __typename?: 'EventCashInfoProxyType', id: number, phones?: Array<string> | null, emails?: Array<string> | null, addresses?: Array<string> | null }>, recurrence?: { __typename?: 'EventRecurrenceProxyType', startDate: any, endDate: any, rrule: string } | null } | null };

export type GetStripeCurrenciesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetStripeCurrenciesQuery = { __typename?: 'Query', stripeCurrencies: Array<{ __typename?: 'CurrencyProxyType', id: number, name?: string | null }> };

export type GetOrganizerPaymentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOrganizerPaymentsQuery = { __typename?: 'Query', organizer: { __typename?: 'OrganizerProxyType', email?: string | null, payments: Array<{ __typename?: 'PaymentsProxyType', id: number, type?: string | null, stripeId?: string | null, country?: string | null, stripeConnectBankAccountId?: string | null }> } };

export type GetEventPaymentsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
}>;


export type GetEventPaymentsQuery = { __typename?: 'Query', eventProxy?: { __typename?: 'EventProxyType', payments: Array<{ __typename?: 'PaymentsProxyType', type?: string | null, stripeConnectBankAccountId?: string | null }> } | null };

export type SetPaymentStripeMutationVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
  paymentId: Types.Scalars['Int']['input'];
  returnUrl: Types.Scalars['String']['input'];
}>;


export type SetPaymentStripeMutation = { __typename?: 'Mutation', setPaymentStripe: { __typename?: 'StripeResponseType', redirectUrl: string, paymentsProxyType: { __typename?: 'PaymentsProxyType', stripeConnectBankAccountId?: string | null } } };

export type DeleteEventGalleryImageMutationVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
  imageId: Types.Scalars['Int']['input'];
}>;


export type DeleteEventGalleryImageMutation = { __typename?: 'Mutation', deleteEventGalleryImage?: { __typename?: 'EventProxyType', id: number } | null };

export type DeleteEventBannerImageMutationVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
}>;


export type DeleteEventBannerImageMutation = { __typename?: 'Mutation', deleteEventBannerImage?: { __typename?: 'EventProxyType', id: number } | null };

export type PublishEventMutationVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
}>;


export type PublishEventMutation = { __typename?: 'Mutation', publishEvent: Array<Types.EventValidationErrorEnum> };

export type GetCountriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'CountryProxyType', country?: string | null, id: number, currency?: string | null, code?: string | null }> };

export type GetOrganizerServiceInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOrganizerServiceInfoQuery = { __typename?: 'Query', activeSubscription: boolean, needVerifyEmail: boolean };

export type TimezonesProxyQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TimezonesProxyQuery = { __typename?: 'Query', timezonesProxy: Array<{ __typename?: 'TimezoneProxyType', id: number, name?: string | null, gmt: string }> };

export type PaymentCountryQueryVariables = Types.Exact<{
  countryCode: Types.Scalars['String']['input'];
}>;


export type PaymentCountryQuery = { __typename?: 'Query', paymentCountry: { __typename?: 'StripeConnectBankAccountCountryType', name: string, currencies: Array<string>, routing: boolean, swift: boolean, number: boolean, iban: boolean } };

export type GetOrganizerBanInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOrganizerBanInfoQuery = { __typename?: 'Query', organizer: { __typename?: 'OrganizerProxyType', banActive: boolean } };

export type DeleteTicketOfficeMutationVariables = Types.Exact<{
  eventId: Types.Scalars['Int']['input'];
}>;


export type DeleteTicketOfficeMutation = { __typename?: 'Mutation', deleteTicketOffice: { __typename?: 'EventProxyType', id: number } };
